import React, { useState } from 'react';
import { FormWithPrivacyHandler } from 'components/molecules/custom-form';
import { useTranslation } from 'hooks/use-translation';
import {
  addACommentOnStore,
  useDiscussionsDispatch,
} from '../discussions-store';
import styles from './reply-comment.module.css';

export const ReplyComment = ({
  projectId,
  docId,
  isPrivateComment,
  discussionThreadId,
  fromPrivateDiscussion,
}) => {
  const replyCommentMsg = useTranslation('reply_small');
  const dispatch = useDiscussionsDispatch();
  const [readonly, setReadOnly] = useState(false);
  const [isPrivate, setIsPrivate] = useState(isPrivateComment);
  const handleReply = async (content) => {
    setReadOnly(true);
    await addACommentOnStore(dispatch, {
      projectId,
      docId,
      discussionThreadId,
      content,
      isPrivate,
    });
    setReadOnly(false);
  };

  return (
    <div className={styles.reply}>
      <FormWithPrivacyHandler
        hidePrivateToggler={fromPrivateDiscussion}
        onSubmit={handleReply}
        isPrivate={isPrivate}
        readonly={readonly}
        placeholder={replyCommentMsg}
        onPrivateBtnClick={() => setIsPrivate(!isPrivate)}
        projectId={projectId}
      />
    </div>
  );
};
